export const BNK_STMT_updateAckScreenMsgsReducer = {
  BNK_STMT_updateAckScreenMsgs: (state, action) => {
    const {
      statusCode,
      statusMsg,
      statusDes,
      bgImg,
      fiboLottieJSON = '',
    } = action.payload;
    if (statusCode) state.ackScreen.statusCode = statusCode;
    if (statusMsg) state.ackScreen.statusMsg = statusMsg;
    if (statusDes) state.ackScreen.statusDes = statusDes;
    if (bgImg) state.ackScreen.bgImg = bgImg;
    state.ackScreen.fiboLottieJSON = fiboLottieJSON;
  },
};
